// pageBox / pageGutter — the app content box (Model B: a boxed app frame).
//
// `pageBox` is the CAP ONLY (centering + max-width, no padding): one centered
// column that EVERY shell band (Navbar, ProjectBanner, slim header) and page
// frame (ProjectLayout, AdminLayout, PlatformLayout) caps itself to, so the whole app is one
// contained column — bands' backgrounds stop at the measure with calm canvas
// wings on ultra-wide (never a full-bleed bar), and the admin rail sits FLUSH to
// the box's left edge (no void). Defined once so the measure can't drift, and so
// any future page stays in the column by rendering inside a frame.
//
// `pageGutter` is the horizontal inset applied by the band CONTENT + the page
// frames (never `pageBox` itself, never the flush rail): responsive — 16px on
// mobile (the standard hamburger/edge inset), 24px from `sm` up. Shared so every
// band + frame insets identically and stays aligned.
//
// Measure = 1920px (Full HD): content fills a 1080p screen edge-to-edge and only
// caps beyond it; this is a contained app for a targeted audience, not a
// fill-the-wall canvas (DESIGN-TOKENS §Content measure). Tunable as pages land.
export const pageBox = 'mx-auto w-full max-w-[120rem]';
export const pageGutter = 'px-4 sm:px-6';
